export default __webpack_public_path__ + "static/media/Hair_4_M_C3.ffd48ea4.svg";